import {
  GET_MENTIONS,
  GET_MENTIONS_FAIL,
  GET_MENTIONS_SUCCESS,
  ADD_NEW_MENTION,
  ADD_MENTION_SUCCESS,
  ADD_MENTION_FAIL,
  UPDATE_MENTION,
  UPDATE_MENTION_SUCCESS,
  UPDATE_MENTION_FAIL,
  DELETE_MENTION,
  DELETE_MENTION_SUCCESS,
  DELETE_MENTION_FAIL,
  
} from "./actionTypes";

export const getMentions = () => ({
  type: GET_MENTIONS,
})

export const getMentionsSuccess = mentions => ({
  type: GET_MENTIONS_SUCCESS,
  payload: mentions,
})

export const getMentionsFail = error => ({
  type: GET_MENTIONS_FAIL,
  payload: error,
})

export const addNewMention = data => ({
  type: ADD_NEW_MENTION,
  payload: data,
})

export const addMentionSuccess = mention => ({
  type: ADD_MENTION_SUCCESS,
  payload: mention,
})

export const addMentionFail = error => ({
  type: ADD_MENTION_FAIL,
  payload: error,
})

export const updateMention = mention => ({
  type: UPDATE_MENTION,
  payload: mention,
})

export const updateMentionSuccess = mention => ({
  type: UPDATE_MENTION_SUCCESS,
  payload: mention,
})

export const updateMentionFail = error => ({
  type: UPDATE_MENTION_FAIL,
  payload: error,
})

export const deleteMention = data => ({
  type: DELETE_MENTION,
  payload: data,
})

export const deleteMentionSuccess = data => ({
  type: DELETE_MENTION_SUCCESS,
  payload: data,
})

export const deleteMentionFail = error => ({
  type: DELETE_MENTION_FAIL,
  payload: error,
})

